enum StreamingStrategy {
    ADD,
    REPLACE,
    NONE
}

export default StreamingStrategy;



// WEBPACK FOOTER //
// ./src/charts/enums/StreamingStrategy.ts